export default "__VITE_ASSET__DVgMsuMp__"